import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import {SearchCategoryModel, SortSearchCategoryModel} from '../Model/SearchCategoryModel'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const SEARCH_CATEGORY_API = `${API_URL}/search-categories`

export const service = {
  getSearchCategory: (params: ParamsModel) => {
    return axios.get(SEARCH_CATEGORY_API, {params})
  },
  getAllSearchCategory: () => {
    return axios.get(`${SEARCH_CATEGORY_API}/list`)
  },

  addSearchCategory: (data: any) => {
    return axios.post(SEARCH_CATEGORY_API, data)
  },

  updateSearchCategory: (body: SearchCategoryModel, id: string) => {
    return axios.patch(`${SEARCH_CATEGORY_API}/${id}`, body)
  },

  deleteSearchCategory: (data: {id: string}) => {
    return axios.delete(SEARCH_CATEGORY_API, {data})
  },

  enableSearchCategory: (data: Array<string>) => {
    const selectedSearchCategory = {
      categoryId: data,
    }
    return axios.patch(`${SEARCH_CATEGORY_API}/enable`, selectedSearchCategory)
  },

  disableSearchCategory: (data: Array<string>) => {
    const selectedSearchCategory = {
      categoryId: data,
    }
    return axios.patch(`${SEARCH_CATEGORY_API}/disable`, selectedSearchCategory)
  },

  singleEnableSearchCategory: (data: Array<string>) => {
    const selectedSearchCategory = {
      categoryId: [data],
    }
    return axios.patch(`${SEARCH_CATEGORY_API}/enable`, selectedSearchCategory)
  },

  singleDisableSearchCategory: (data: Array<string>) => {
    const selectedSearchCategory = {
      categoryId: [data],
    }
    return axios.patch(`${SEARCH_CATEGORY_API}/disable`, selectedSearchCategory)
  },
  sortSearchCategory: (body: SortSearchCategoryModel) => {
    return axios.patch(`${SEARCH_CATEGORY_API}/sort`, body)
  },
}
